import moment from "moment";
// sync side-effect: moment-range@2 extends the same moment singleton.
// Dynamic import() left .range missing → "moment.range is not a function".
import "moment-range";

export default moment;
